var Globalize = require("./globalize.js");
window.Globalize = Globalize;
//require("./cultures/globalize.culture.da-dk.js");
exports.Globalize = Globalize;



/*****************
 ** WEBPACK FOOTER
 ** ./Content/Plugins/globalize/globalize-includer.js
 ** module id = 40
 ** module chunks = 15
 **/